import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft, FaExclamationCircle } from "react-icons/fa";
import PatientDetails from "./PatientDetails";
import ItemsTable from "./ItemsTable";
import PaymentSummary from "./PaymentSummary"; // Import the new component
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";

const PrescriptionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: precriptionData, isLoading } = useItemsFilter(
    ApiEndPoint.PHARMACY,
    `?action=getPharmacyBill&id=${id}`,
    id ? true : false
  );

  // Check if the bill is published but there are no payment allocations
  const isPaymentPending =
    precriptionData?.status === "published" &&
    (!precriptionData?.payment_allocations ||
      precriptionData.payment_allocations.length === 0);

  return (
    <div className="bg-gray-100 min-h-screen p-4 sm:p-6">
      <div className="flex items-center justify-between mb-6">
        {/* Back Button on the left with an arrow icon */}
        <button
          className="flex items-center text-white bg-green-600 px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft className="mr-2" />
          Back
        </button>
        {/* Centered Title */}
        <h2 className="text-2xl font-bold text-gray-800">Billing Details</h2>
        {/* Action Button on the right */}
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
          onClick={() => navigate(`/new/pharmacy/bill/create/${id}`)}
        >
          + Go For Billing
        </button>
      </div>

      {/* Payment Pending Banner */}
      {!isLoading && precriptionData && isPaymentPending && (
        <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-2 rounded-lg mb-6 flex items-center space-x-2">
          <FaExclamationCircle />
          <span>
            Payment is pending. Please go for billing and complete the payment.
          </span>
        </div>
      )}

      {isLoading ? (
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
        </div>
      ) : (
        <>
          <PatientDetails
            prescription={precriptionData?.patient_id}
            date_created={precriptionData?.date_created}
          />
          {/* <MedicinesTable medicines={precriptionData?.medicine_details || []} /> */}
          <ItemsTable items={precriptionData?.billing_item} />
          <PaymentSummary
            paymentSummary={precriptionData?.payment_summary}
            paymentAllocations={precriptionData?.payment_allocations}
          />
        </>
      )}
    </div>
  );
};

export default PrescriptionDetail;
